"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLengthCountry = void 0;

var getLengthCountry = function getLengthCountry(input) {
  switch (input) {
    case 'AL':
      return 28;

    case 'DE':
      return 22;

    case 'AD':
      return 24;

    case 'SA':
      return 24;

    case 'AT':
      return 20;

    case 'AZ':
      return 28;

    case 'BH':
      return 22;

    case 'BY':
      return 28;

    case 'BA':
      return 20;

    case 'BR':
      return 29;

    case 'BG':
      return 22;

    case 'BE':
      return 16;

    case 'CY':
      return 28;

    case 'CR':
      return 22;

    case 'HR':
      return 21;

    case 'DK':
      return 18;

    case 'SV':
      return 28;

    case 'AE':
      return 23;

    case 'SI':
      return 19;

    case 'ES':
      return 24;

    case 'EE':
      return 20;

    case 'FI':
      return 18;

    case 'FR':
      return 27;

    case 'GE':
      return 22;

    case 'GI':
      return 23;

    case 'GR':
      return 27;

    case 'GL':
      return 18;

    case 'GT':
      return 28;

    case 'NL':
      return 18;

    case 'HU':
      return 28;

    case 'IQ':
      return 23;

    case 'IE':
      return 22;

    case 'IS':
      return 26;

    case 'FO':
      return 18;

    case 'VG':
      return 24;

    case 'IL':
      return 23;

    case 'IT':
      return 27;

    case 'JO':
      return 30;

    case 'KZ':
      return 20;

    case 'XK':
      return 20;

    case 'KW':
      return 30;

    case 'LV':
      return 21;

    case 'LI':
      return 21;

    case 'LT':
      return 20;

    case 'LU':
      return 20;

    case 'LB':
      return 28;

    case 'MK':
      return 19;

    case 'MT':
      return 31;

    case 'MU':
      return 30;

    case 'MR':
      return 27;

    case 'MD':
      return 24;

    case 'ME':
      return 22;

    case 'MC':
      return 27;

    case 'NO':
      return 15;

    case 'PK':
      return 24;

    case 'PS':
      return 29;

    case 'PL':
      return 28;

    case 'PT':
      return 25;

    case 'QA':
      return 29;

    case 'GB':
      return 22;

    case 'CZ':
      return 24;

    case 'DO':
      return 28;

    case 'RO':
      return 24;

    case 'SM':
      return 27;

    case 'LC':
      return 32;

    case 'ST':
      return 25;

    case 'RS':
      return 22;

    case 'SC':
      return 31;

    case 'SK':
      return 24;

    case 'SE':
      return 24;

    case 'CH':
      return 21;

    case 'TL':
      return 23;

    case 'TR':
      return 26;

    case 'TN':
      return 24;

    case 'UA':
      return 29;

    default:
      return 0;
  }
};

exports.getLengthCountry = getLengthCountry;